import styled, { css } from "styled-components";

export const Container = styled.div`
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);

    position: fixed;
    top: 0;
    right: 0;
    z-index: -9;
    opacity: 0;

    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #535354;

    ${props => props.modalFormsGenericIsOpen && css`
        opacity: 1;
        z-index: 999;
    `}
`

export const Content = styled.div`
    height: 90vh;
    width: 100%;
    max-width: 700px;
    padding: 4rem;
    background: #FFF;
    border-radius: 10px;
    position: relative;

    overflow-y: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;

    button{
        margin-top: 3rem;
    }

    @media (max-width: 700px){
        height: 100%;
        border-radius: 0;
        padding: 3rem 0.5rem;
    }
`

export const Form = styled.div`
     margin-top: 2rem;

    .normalInput{
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 0.5rem;
    }

    .inputFile{
        margin-top: 2rem;
    }

    .inputText{
        display: flex;
        align-items: center;
    }

    .dateInputs{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 2rem 0;

        p{
            font-weight: 500;
            font-size: 1.2rem;
            margin: 0.5rem 1rem;
        }

        input{
            padding: 0.7rem;
            color: #7A05A7;
            border: none;
            outline: none;
            font-weight: 500;
            font-size: 1rem;
            border-radius: 0.25rem;
            position: relative;
            border: 1px solid #7A05A7;
            flex: auto;
        }

        input::-webkit-calendar-picker-indicator {
            color: transparent;
            background: none;
            z-index: 1;
            
            @media (min-width: 960px){
                cursor: pointer;
            }
        }

        input:before {
            color: transparent;
            background: none;
            display: block;
            font-family: 'material icons';
            content: 'date_range';
            width: 1rem;
            position: absolute;
            top: 50%;
            right: 6px;
            color: #7A05A7;
            transform: translateY(-50%);
        }

        @media (max-width: 480px){
            justify-content: center;
            flex-direction: column;
        }
    }
`

export const ImageUploader = styled.div`
    margin-top: 2rem;

    .imageArea{
        width: 100%;
        height: 15rem;
        border: ${props => props.img ? 'none' : '2px dashed #CCC'};
        border-radius: 10px;
        position: relative;
        overflow: hidden;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;


        img{
            height: 100%;
            width: 100%;
            position: absolute;
            object-fit: contain;
            display: ${props => props.img ? 'block' : 'none'};
        }
       

        svg{
            color: #7A05A7;
            font-size: 5rem;
        }

        div{
            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;
            color: #FFF;
            background: linear-gradient(135deg, #d10089 0%, #7A05A7 100%);
            padding: 0.5rem 0;
            font-size: 1.2rem;
            transform: translateY(100%);
            z-index: 9;
            transition: transform 0.3s ease;
        }

        .closeButton{
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 1.2rem;
            color: #7A05A7;
            transform: translateY(-150%);
            z-index: 9;
            transition: transform 0.3s ease;
            cursor: pointer;
        }

        ${props => props.img && css`
            &:hover{
                .closeButton, div{
                    transform: translateY(0);
                }
            }
        `}
    }

    button{
        border: none;
        margin-top: 1rem;
        padding: 0.75rem 0;
        width: 100%;
        color: #FFF;
        background: linear-gradient(135deg, #d10089 0%, #7A05A7 100%);
        font-size: 1rem;
        border-radius: 15px;
        font-weight: 500;
        letter-spacing: 1px;
        outline: none;
    }
`